module.exports = __webpack_public_path__ + "img/browser-ie-logo.6408c30a.png";